import React, { Component } from "react";
import { Link } from "react-router-dom";

//styles
import {
  Container,
  Trends,
} from "./styles";

// //Components
// import AloComponent from "../../components/alos/AloComponent";
// import Banner from "../../components/BannerComponent";

//elements
// import { EditorialCard } from "../../elements/Card";

import EpisodeCard from "../../components/EpisodeCardComponent";

// import { Title } from "../../elements/Typography";
import { Wrapper } from "../../elements/Layout";

import M from "materialize-css";
import { ChevronRight } from "styled-icons/material";
import { ChevronLeft } from "styled-icons/material";
import { ACCESS_TOKEN, USER_ACCOUNT } from '../../constants';
import SobreCanal from "./SobreCanal";
// import OlaFrontWeb from "../../assets/img/OlaFrontWeb.jpg";


// icons generos
import { Cotidiano, Conhecimento, Variedades, Humor, Familia, Historias, LifeStyle, Mercado, Esportes, Tecnologia } from "../../assets/icons";

//images
// import BANNER_BOTTOM from "../../assets/img/ola_15dias.jpg";
// import TOP_CORONA from "../../assets/img/corona_top.png";
// import BANNER_NESTLE from "../../assets/img/banners/banner_nestle.jpeg";

// const generos = [
//   {
//     icon: <Cotidiano className="icon" />,
//     name: "Cotidiano",
//     class: "cotidiano",
//     catecory: 5
//   },
//   {
//     icon: <Conhecimento className="icon" />,
//     name: "Conhecimento",
//     class: "conhecimento",
//     catecory: 7
//   },
//   {
//     icon: <Variedades className="icon" />,
//     name: "Variedades",
//     class: "variedades",
//     catecory: 2
//   },
//   {
//     icon: <Humor className="icon" />,
//     name: "Humor",
//     class: "humor",
//     catecory: 1
//   },
//   {
//     icon: <Familia className="icon" />,
//     name: "Família",
//     class: "familia",
//     catecory: 9
//   },
//   {
//     icon: <Historias className="icon" />,
//     name: "Histórias",
//     class: "historias",
//     catecory: 8
//   },
//   {
//     icon: <LifeStyle className="icon" />,
//     name: "Lifestyle",
//     class: "lifestyle",
//     catecory: 3
//   },
//   {
//     icon: <Mercado className="icon" />,
//     name: "Mercado",
//     class: "mercado",
//     catecory: 6
//   },
//   {
//     icon: <Esportes className="icon" />,
//     name: "Esportes",
//     class: "esportes",
//     catecory: 4
//   },
//   {
//     icon: <Tecnologia className="icon" />,
//     name: "Tecnologia",
//     class: "tecnologia",
//     catecory: 10
//   }
// ];

function visualise(object,ind){
  if(object){
    object.forEach((element) => {
      if(element.episode.id === ind){
        return true;
      }
    })
  }
  return false; 
}

class Browse extends Component {
  constructor(props) {
    super(props)
    this.state = {
      instanceOptions: {
        numVisible: 3,
        duration: 0,
        dist: 0,
        padding: 0,
        fullWidth: true,
      }
    }
    this.textRef = React.createRef();
  }
  componentDidMount(){
    
    // if(window.location.pathname.includes('cadastro')){
    //   var elems = document.getElementById('signup');
    //   // console.log("Elems: ",elems);
    //   var instances = M.Modal.init(elems, {
    //       onOpenStart: function () {
    //           var ev = new CustomEvent('modal-entrar', { "detail": "register"});
    //           document.dispatchEvent(ev);
    //     }
    //   });
    //   var instance = M.Modal.getInstance(elems);
    //   instance.open();
    // }
    // EDITORIAL OUVINDO CARROSEL
    // let elementAlo = document.querySelectorAll('.contentAlos');
    // this.instanceAlo = M.Carousel.init(elementAlo,this.state.instanceOptions);

    // EDITORIAL OUVINDO CARROSEL
    // let elem = document.querySelectorAll('#editorial-carrosel');
    // this.instance = M.Carousel.init(elem,this.state.instanceOptions);

    // CONTINUAR OUVINDO CARROSEL
    // this.elementContinue = document.querySelectorAll("#continuar-ouvindo-carrosel");
    // this.instanceContinue = M.Carousel.init(this.elementContinue,this.state.instanceOptions);

    // MINHAS INSCRICOES CARROSEL
    // this.elementInscricoes = document.querySelectorAll("#minhas-inscricoes-carrosel");
    // this.instanceInscricoes = M.Carousel.init(this.elementInscricoes,this.state.instanceOptions);

    // EM ALTA CARROSEL
    this.elementEnAlta = document.querySelectorAll("#em-alta-carrosel");
    this.instanceEnAlta = M.Carousel.init(this.elementEnAlta,this.state.instanceOptions);

    // // RECOMENDADOS CARROSEL
    // this.elementRecomendados = document.querySelectorAll("#recommended-carrosel");
    // this.instanceRecomendados = M.Carousel.init(this.elementRecomendados,this.state.instanceOptions);

    // PREMIUM CARROSEL
    // this.elementPremium = document.querySelectorAll("#premium-carrosel");
    // this.instancePremium = M.Carousel.init(this.elementPremium,this.state.instanceOptions);
  }
  

  //   abreModalCadastro = () => {
  //     var elems = document.getElementById('signup');
  //     // console.log("Elems: ",elems);
  //     var instances = M.Modal.init(elems, {
  //         onOpenStart: function () {
  //             var ev = new CustomEvent('modal-entrar', { "detail": "register"});
  //             document.dispatchEvent(ev);
  //       }
  //     });
  //     var instance = M.Modal.getInstance(elems);
  //     instance.open();
  // }

  render(){
    //let userAccount = JSON.parse(localStorage.getItem(USER_ACCOUNT));
    const {  
      // trends,
      // topChannels,
      // recommendedEpisodes,
      // premium,
      allPlaybacks,
      // userAllEpisodesFollowing,
      // homeFeaturedAlos,
      // editorialList,
      top,
      // bottom,
      linkedWebsite
    } = this.props;
    let d = new Date().getTime();
    let timestamp = parseInt(d / 1000);
    let newArrTop = [];
    if(top && top.data){
      top.data.map(
        top => {
          if(
            top.initialDate && top.initialDate <= timestamp && 
            top.finalDate && top.finalDate >= timestamp
          ){
            newArrTop.push(top);
          }
        }
      )
      //newArrTop = top.data;
    }
    // {!!userAccount && userAccount.nestle &&
    //   newArrTop.unshift({id: 'banner_nestle', title: 'Nestlé', description: 'Banner Nestle', action: 'channel', arguments: 'falanestle', hide_title: false, hide_description: false, visibility: "all", hint_position: "none", cover: BANNER_NESTLE})
    // }
    //top.data = newArrTop;

    // PAGINACAO CARROCEIS
    // const continueNext = () => { this.instanceContinue[0].next(1); }
    // const inscricoesNext = () => { this.instanceInscricoes[0].next(1); }
    const enAltaNext = (i) => { this.instanceEnAlta[i].next(1); }
    const enAltaPrev = (i) => { this.instanceEnAlta[i].prev(1); }
    // const recomendadosNext = () => { this.instanceRecomendados[0].next(1); }
    // const premiumNext = () => { this.instancePremium[0].next(1); }
    return(
    <Container className="margin-to-top">
      {
      linkedWebsite && 
      linkedWebsite.channels_with_configs && 
      linkedWebsite.channels_with_configs.data &&
      linkedWebsite.channels_with_configs.data.map(
        (channelConfig,index) => {
          channelConfig.title_color = channelConfig.text_color;
          return <div key={index} className="page-home " style={{background: channelConfig.background_color}}>
            <div className="container">
              <div className="row" style={{marginBottom: 0}}>
                <div className="col-md-3 col-sm-12">
                  <Link to={`/channels/${channelConfig.channel.codename}`} className="title-channel">
                    {channelConfig.channel.name}
                  </Link>
                  <div className="channel-aling-image">
                    <Link to={`/channels/${channelConfig.channel.codename}`}>
                      <img src={channelConfig.channel.thumbnail} style={{width: "80%", marginTop: "2.6rem", marginBottom: "1rem"}}/>
                    </Link>
                  </div>
                  <SobreCanal channel={channelConfig.channel}
                   />
                  {/*
                  <h5 className="subtilteChannel">SOBRE O CANAL</h5>
                  <span ref={this.textRef} className="description">{channelConfig.channel.description}</span>
                  */}
                </div>
                <Trends className="trends col-md-9 col-sm-12">
                  <Wrapper
                    alignItems="center"
                    justifyContent="flex-start"
                    className="trends-header"
                  >
                    <h5 className="trend-title" style={{color: channelConfig.text_color}}>Últimos episódios</h5>
                    <div className="content-pagination">
                      <a className="pagination" style={{color: channelConfig.text_color}}
                        onClick={() => enAltaPrev(index)}
                      >
                        <ChevronLeft className="paginationIcon" />
                      </a>
                      <a className="pagination" style={{color: channelConfig.text_color}}
                        onClick={() => enAltaNext(index)}
                      >
                        <ChevronRight className="paginationIcon" />
                      </a>
                    </div>
                  </Wrapper>
                  <Wrapper className="trend-list em-alta">
                    <div id="em-alta-carrosel" className="episodes-carousel carousel">
                      {
                        channelConfig.channel.episodes.data.map(
                          (episode) => {
                            return (
                              <div key={`em-alta-ep-${episode.id}`} className="content-colon carousel-item"  style={{background: channelConfig.background_color}}>
                                <EpisodeCard 
                                  episode={episode} 
                                  visualise={visualise(allPlaybacks,episode.id )} 
                                  currentDate={true} 
                                  showDetails={true} 
                                  area="em-alta"
                                  channelConfig={channelConfig}
                                />
                              </div>
                            )
                          }
                        )
                      }
                    </div>
                  </Wrapper>
                </Trends>
              </div>
            </div>
          </div>
        }
      )
      }
      
    </Container>
    
    );
  }
}

export default Browse;
